export enum UiComponentSetting {
  AutoStart = 'AutoStart',
  AssignSubDriver = 'AssignSubDriver',
  AddPayoutAdjustment = 'AddPayoutAdjustment',
  FindDriver = 'FindDriver',
  ChangeRideTime = 'ChangeRideTime',
  WaitingTime = 'WaitingTime',
  SendRideOffer = 'SendRideOffer',
  AutoAccept = 'AutoAccept',
  ResetRide = 'ResetRide',
  ResetStop = 'ResetStop',
  StopsActivityLog = 'StopsActivityLog',
  RideActivity = 'RideActivity',
  CompleteRide = 'CompleteRide',
  DeleteRide = 'DeleteRide',
  IgnoreDriverDoubleBooked = 'IgnoreDriverDoubleBooked',
  IgnoreMonitorDoubleBooked = 'IgnoreMonitorDoubleBooked',
  UnassignDriver = 'UnassignDriver',
  AddIncidentReport = 'AddIncidentReport',
  SendDelayNotification = 'SendDelayNotification',
  MassCancellation = 'MassCancellation',
  SendGroupMessage = 'SendGroupMessage',
  CancelTransportation = 'CancelTransportation',
  ChangeStopCargoStatus = 'ChangeStopCargoStatus',
  ChangeCancellationType = 'ChangeCancellationType',
  ShowDriverMessaging = 'ShowDriverMessaging',
  ShowGuardianMessaging = 'ShowGuardianMessaging',
  ShowPeriodFilter = 'ShowPeriodFilter',
  ShowPlaceFilter = 'ShowPlaceFilter',
  ShowContractorFilter = 'ShowContractorFilter',
  ShowClientFilter = 'ShowClientFilter',
  ShowClientIdsFilter = 'ShowClientIdsFilter',
  ShowServiceAreaFilter = 'ShowServiceAreaFilter',
  ShowServiceRegionFilter = 'ShowServiceRegionFilter',
  ShowStatusFilter = 'ShowStatusFilter',
  ShowDriverProviderFilter = 'ShowDriverProviderFilter',
  ShowPassengerFilter = 'ShowPassengerFilter',
  ShowRideIdFilter = 'ShowRideIdFilter',
  ShowFromTimeFilter = 'ShowFromTimeFilter',
  ShowToTimeFilter = 'ShowToTimeFilter',
  ShowShowAllFilter = 'ShowShowAllFilter',
  ShowWithNotesFilter = 'ShowWithNotesFilter',
  ShowEquipmentGridIcon = 'ShowEquipmentGridIcon',

  viewContractorBasicInfo = 'viewContractorBasicInfo', // admin, client
  viewDriverProviderContacts = 'viewDriverProviderContacts', // admin
  viewBankInformation = 'viewBankInformation', // admin
  viewVehicleDetails = 'viewVehicleDetails', // admin, client 
  viewContractorNotificatoins = 'viewContractorNotificatoins', // admin
  viewContractorDeviceInfo = 'viewContractorDeviceInfo', // admin
  viewBPSheetDetails = 'viewBPSheetDetails', // admin, client 
  viewBPSheetStops = 'viewBPSheetStops', // admin, client
  viewBPSheetEquipment = 'viewBPSheetEquipment', // admin, client
  viewBPSheetClanedars = 'viewBPSheetClanedars', // admin, client
  viewClientContacts = 'viewClientContacts', // admin
  viewDestinationTable = 'viewDestinationTable', // admin, client
  viewStudentsTable = 'viewStudentsTable', // admin, client
  viewPaymentDetails = 'viewPaymentDetails', // admin
  viewPlaceInstructions = 'viewPlaceInstructions', // admin

  viewNoteActivityLog = 'viewNoteActivityLog',
  viewActivityLog = 'viewActivityLog',
  viewStopsActivityLog = 'viewStopsActivityLog',
  viewChangeTimeZoneDll = 'viewChangeTimeZoneDll',
  ShowStateFilter = 'ShowStateFilter',
  ShowEquipmentTypeFilter = 'ShowEquipmentTypeFilter',
  ShowEquipmentNeedFilter = 'ShowEquipmentNeedFilter',
  ShowCancellationReasonFilter = 'ShowCancellationReasonFilter',
  hasCameraIconPermission = 'ShowCameraIcon',
  CancelStudentRide = 'MassStudentCancellation',
  viewGPSPingsData = 'GpsPingsActivityLogs',
}
